import { ACTION_TYPE } from './action';

const mailMagazineEntry = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_ENTRY_SUCCESS:
      return {
        ...state,
        selects: action.selects,
        initSuccess: true,
      };
    case ACTION_TYPE.CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS_SUCCESS:
      return {
        ...state,
        members: action.members,
      };
    case ACTION_TYPE.CALL_API_MAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: action.templates,
      };
    case ACTION_TYPE.RESET_MAIL_MAGAZINE_MEMBERS:
      return {
        ...state,
        members: [],
      };
    default:
      return state;
  }
};

export default mailMagazineEntry;
